import moment from "moment";
import { v4 as uuidv4 } from "uuid";

// the library has bug when taking parameter to transform in array item
var objectMapper = require("object-mapper");

export const getRateResponseMapper = (data: any) => {
  return objectMapper(data, map)
    .filter((rate: any) => rate.account.isActive)
    .map((rate: any) => {
      return {
        ...rate,
        transitDay:
          !rate?.transitDay &&
          rate.arrivalDate &&
          rate.arrivalDate !== "0001-01-01T00:00:00"
            ? moment(rate.arrivalDate).diff(moment(), "days") + 1
            : rate.transitDay,
      };
    });
};

export const map = {
  "[].id": {
    key: "[].id",
    transform: () => uuidv4().replaceAll("-", ""),
  },
  "[].shippingService.expectedTransitTime": "[].transitDay",
  "[].shippingService.expectedArrivalTime": "[].arrivalTime",
  "[].shippingService.expectedDeliveryDate": "[].arrivalDate",
  "[].shippingService.isSaturdayDelivery":
    "[].shippingService.isSaturdayDelivery",
  "[].shippingService.isHoldForPickup": "[].shippingService.isHoldForPickup",
  "[].shippingService.saturdayDeliveryDisclaimer":
    "[].shippingService.saturdayDeliveryDisclaimer",
  "[].options[].name": "[].serviceOptions[].name",
  "[].options[].isIncluded": "[].serviceOptions[].isIncluded",
  "[].shippingCarrierAccount.carrier_code": "[].carrierName",
  "[].shippingCarrierAccount.id": "[].account.id",
  "[].shippingCarrierAccount.account_nickname": "[].account.name",
  "[].shippingCarrierAccount.account_type": "[].account.accountType",
  "[].shippingCarrierAccount.is_active": "[].account.isActive",
  "[].shippingService.name": "[].service.serviceName",
  "[].shippingService.serviceType": "[].service.serviceCode",
  "[].shippingService.subServiceTypes[].name":
    "[].service.subservices[].serviceName",
  "[].shippingService.subServiceTypes[].serviceType":
    "[].service.subservices[].serviceCode",
  "[].shipmentCharges.totalCharge.currency": "[].price.currency",
  "[].shipmentCharges.totalCharge.amount": "[].price.totalCharge",
  "[].shipmentCharges.adjustments[].name": "[].price.adjustments[].name",
  "[].shipmentCharges.adjustments[].price.amount":
    "[].price.adjustments[].amount",
  "[].shipmentCharges.shipOptions[].name": "[].price.optionsCharge[].name",
  "[].shipmentCharges.shipOptions[].code": "[].price.optionsCharge[].code",
  "[].shipmentCharges.shipOptions[].price.currency":
    "[].price.optionsCharge[].currency",
  "[].shipmentCharges.shipOptions[].price.amount":
    "[].price.optionsCharge[].amount",
  "[].shipmentCharges.taxes[].name": "[].price.taxes[].name",
  "[].shipmentCharges.taxes[].price.amount": "[].price.taxes[].amount",
  "[].shipmentCharges.baseCharge.amount": "[].price.baseCharge",
  "[].shipmentCharges.additionalCharges[].price.amount":
    "[].price.additionalCharges[].amount",
  "[].shipmentCharges.additionalCharges[].name":
    "[].price.additionalCharges[].name",
  "[].shipmentCharges.baseChargeInBaseCurrency": "[].baseCurrency",
};
